import { Component, ContextType } from 'react'
import { createPortal } from 'react-dom'
import { Language } from '../../globals'
import { ReactComponent as CheckIcon } from '../../assets/check.svg'
import { ReactComponent as CloseIcon } from '../../assets/close.svg'
import { ReactComponent as DownClaretIcon } from '../../assets/down_claret.svg'
import { ReactComponent as LanguageIcon } from '../../assets/language.svg'
import LocalizationContext from '../../contexts/Localization/LocalizationContext'

export type LanguageSwitchProps = {
  onSwitchLanguage: (activeLanguage: Language) => Promise<void>
  languages?: Language[]
  activeLanguage: Language | null
  hideMenu: () => void
  modalRootRef: HTMLDivElement | null
}

class LanguageSwitch extends Component<LanguageSwitchProps> {
  static contextType = LocalizationContext
  context!: ContextType<typeof LocalizationContext>

  state = {
    isMenuActive: false,
    languageToSwitch: {} as Language
  }

  setActiveLanguage = (activeLanguage: Language) => {
    const { onSwitchLanguage, hideMenu } = this.props
    this.setState({ isMenuActive: false })
    onSwitchLanguage(activeLanguage)
    hideMenu()
  }

  setIsMenuActive = (isMenuActive: boolean) => {
    this.setState({ isMenuActive })
  }

  render() {
    const { getLocalizedString } = this.context
    const { languages, activeLanguage, modalRootRef } = this.props
    const { isMenuActive, languageToSwitch } = this.state
    const isModalOpen = Object.keys(languageToSwitch || {}).length > 0

    if(!languages?.length){
      return null;
    }

    return (
      <li>
        <button
          className="btn"
          onClick={() => this.setIsMenuActive(!isMenuActive)}
        >
          <LanguageIcon className="menu-icon" />
          <span className="menu-main-text">
            {activeLanguage?.label} <CheckIcon />
          </span>
          <DownClaretIcon
            className={`dropdown-icon  ${isMenuActive ? 'open' : ''}`}
          />
        </button>
        <div className={`lang-list ${isMenuActive ? 'open' : ''}`}>
          {languages.map((lang) => {
            const isActive = lang.locale === activeLanguage?.locale
            return (
              <button
                key={lang.locale}
                className={'btn lang-item' + (isActive ? ' is-active' : '')}
                onClick={() =>
                  !isActive &&
                  this.setState({
                    languageToSwitch: lang
                  })
                }
                disabled={isActive}
              >
                <LanguageIcon className="menu-icon" />
                <span className="menu-main-text">{lang.label}</span>
                {isActive && <CheckIcon className="active-check" />}
              </button>
            )
          })}
        </div>
        {createPortal(
          isModalOpen && (
            <div className="header-modal">
              <div className="header-modal-body">
                <button
                  className="close-btn"
                  onClick={() => this.setState({ languageToSwitch: {} })}
                >
                  <CloseIcon />
                </button>
                {getLocalizedString(
                  'languageSwitchPrompt',
                  // eslint-disable-next-line max-len
                  'If you change languages, your ongoing conversation will end, do you want to continue?'
                )}
                <button
                  className="stop-btn"
                  onClick={() => {
                    this.setActiveLanguage(languageToSwitch)
                    this.setState({ languageToSwitch: {} })
                  }}
                >
                  {getLocalizedString(
                    'languageSwitchPromptButton',
                    'Change to {language}'
                  ).replace(/{language}/gi, languageToSwitch.label)}
                </button>
              </div>
            </div>
          ),
          modalRootRef as Element
        )}
      </li>
    )
  }
}

export default LanguageSwitch
